export default "__VITE_ASSET__Dslq8gs1__"